import styled, { css } from 'styled-components';
import { rem } from 'polished';
import Button from '@atoms/Button/Button';
import Config from '@config';
import variables from '@styles/variables';
import { FullScreen } from 'react-full-screen';
import Image from 'next/image';

export const StyledFullscreen = styled(FullScreen)<{ $fullScreen?: boolean }>`
  ${(props) =>
    props.$fullScreen &&
    css`
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 9999;
      background-color: ${variables.colors.white};
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    `}
`;

export const Wrapper = styled.div<{ $fullScreen?: boolean }>`
  margin-top: ${rem(40)};

  ${(props) =>
    props.$fullScreen &&
    css`
      margin-top: 0;
      width: ${rem(408)};
    `}
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const QrContainer = styled.div`
  margin-top: ${rem(50)};
  margin-bottom: ${rem(80)};

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    cursor: pointer;
    width: ${rem(140)};
    margin-left: auto;
    margin-right: auto;
  }
`;

export const StyledClearIntervalsButton = styled(Button)`
  width: 100%;
  margin-bottom: ${rem(40)};
  margin-top: ${rem(16)};
`;

export const StyledBankIdImage = styled(Image)`
  height: auto;
  margin-bottom: ${rem(36)};
`;
